import { createContext } from 'react';
import type { VaultNewRecordsByTable, VaultSeenRecords } from './types';

export interface VaultNewRecordsValue {
  /** Unseen record ids per vault table. */
  byTable: VaultNewRecordsByTable;
  /**
   * Marks exactly these records as seen: drops those ids from `byTable` and sends them to the API
   * (a mark that arrives later is not in them).
   */
  markSeen: (records: VaultSeenRecords) => void;
}

/** No provider mounted (public pages, HLX, most specs): nothing is new and nothing is marked. */
export const EMPTY_VAULT_NEW_RECORDS: VaultNewRecordsValue = {
  byTable: {},
  markSeen: () => undefined,
};

export const VaultNewRecordsContext = createContext<VaultNewRecordsValue>(EMPTY_VAULT_NEW_RECORDS);
